"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboardStats = void 0;
const React = __importStar(require("react"));
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const AdminMGTProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/AdminMGTProvider");
const canisters_1 = require("src/hello_assets/src/util/canisters");
const CopyablePrincipalComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CopyablePrincipalComponent");
const AdminDashboardStats = () => {
    var _a, _b, _c, _d;
    const context = (0, AdminMGTProvider_1.useAdminMGTContext)();
    const loading = context.status.inProgress && !context.status.loaded;
    const valueRender = node => {
        return loading ? React.createElement(antd_1.Spin, null) : node;
    };
    const information = (_a = context.data) === null || _a === void 0 ? void 0 : _a.information;
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Row, { gutter: [32, 16] },
                React.createElement(antd_1.Col, null,
                    React.createElement(antd_1.Statistic, { title: "Projects", value: (_b = information === null || information === void 0 ? void 0 : information.management) === null || _b === void 0 ? void 0 : _b.projectsTotal, valueRender: valueRender })),
                React.createElement(antd_1.Col, null,
                    React.createElement(antd_1.Statistic, { title: "Usergeek Users", value: (_c = information === null || information === void 0 ? void 0 : information.analyticsStoreTotal) === null || _c === void 0 ? void 0 : _c.participantsTotal, valueRender: valueRender })),
                React.createElement(antd_1.Col, null,
                    React.createElement(antd_1.Statistic, { title: "DAU Total", value: (_d = information === null || information === void 0 ? void 0 : information.analyticsStoreTotal) === null || _d === void 0 ? void 0 : _d.allClients, valueRender: valueRender })))),
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(AnalyticsStoreCard, { info: information === null || information === void 0 ? void 0 : information.analyticsStore, canisterId: canisters_1.Canisters.analyticsStore, name: "analyticsStore" }),
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(AnalyticsStoreCard, { info: information === null || information === void 0 ? void 0 : information.analyticsStore2, canisterId: canisters_1.Canisters.analyticsStore2, name: "analyticsStore2" }));
};
exports.AdminDashboardStats = AdminDashboardStats;
const AnalyticsStoreCard = (props) => {
    var _a, _b, _c;
    return React.createElement(PageContent_1.default.Card, null,
        React.createElement("div", null,
            props.name,
            " ",
            React.createElement(CopyablePrincipalComponent_1.CopyablePrincipalComponent, { principal: props.canisterId, color: "lightgray" })),
        React.createElement(antd_1.Row, { gutter: [32, 16] },
            React.createElement(antd_1.Col, null,
                React.createElement(antd_1.Statistic, { title: "Active Projects", value: (_a = props.info) === null || _a === void 0 ? void 0 : _a.projectsWithUsers })),
            React.createElement(antd_1.Col, null,
                React.createElement(antd_1.Statistic, { title: "Usergeek Users", value: (_b = props.info) === null || _b === void 0 ? void 0 : _b.participantsTotal })),
            React.createElement(antd_1.Col, null,
                React.createElement(antd_1.Statistic, { title: "DAU Total", value: (_c = props.info) === null || _c === void 0 ? void 0 : _c.allClients }))));
};
